import { gql } from '@apollo/client';

/**
 * Teacher-only join hints for the lesson journal: which students clicked the
 * "join lesson" button and when. Operation name intentionally differs from the
 * backend field (`lmsLessonJoinClicks`).
 */
export const LessonJoinClicksQuery = gql`
  query LessonJoinHints($groupLessonId: Int!) {
    lmsLessonJoinClicks(groupLessonId: $groupLessonId) {
      studentId
      studentName
      clickedAt
    }
  }
`;
